<template>
<div class="chapter">
<div class="inner_page">
<h3 class="calibre4">Sonnenflug</h3>
<p class="vers">Ein Häher schwimmt aus der Fichte<br class="calibre2"/>
dunkel wogender Krone.<br class="calibre2"/>
Er kreist im Abendlichte<br class="calibre2"/>
einer glühenden Zone.</p>
<p class="vers">Drauf bauscht er die Brust mit Wonne,<br class="calibre2"/>
breitet lässig die Flügel,<br class="calibre2"/>
fährt dahin, wo die Sonne<br class="calibre2"/>
schwindet hinter dem Hügel.</p>
<p class="vers">Mit gebietendem Fluge,<br class="calibre2"/>
glutengekrönter Stirne<br class="calibre2"/>
folgt er dem Flammenzuge,<br class="calibre2"/>
wähnt sich im Reich der Gestirne.</p>
<p class="vers"><a class="pcalibre pcalibre3 pcalibre1 pcalibre2" id="page21" title="wedi/Konmax"></a> Hat der eigenen Schwere<br class="calibre2"/>
majestätisch vergessen,<br class="calibre2"/>
drängt in die Strahlenmeere<br class="calibre2"/>
seine Schwingen vermessen.</p>
<p class="vers">Tiefer sinken die Gluten,<br class="calibre2"/>
rauschend hebt sich der Häher.<br class="calibre2"/>
Hoch in weltfernen Fluten<br class="calibre2"/>
wiegt sich der einsame Späher.</p>
<p class="vers">Nur ein ersterbender Schimmer<br class="calibre2"/>
liegt, wo die Sonne gesunken;<br class="calibre2"/>
doch noch immer, noch immer<br class="calibre2"/>
steigt er, vom Lichte trunken.</p>
<p class="vers">Gierig saugen die Blicke,<br class="calibre2"/>
saugen ein glühend Verderben;<br class="calibre2"/>
sinkt er ermattet zurücke,<br class="calibre2"/>
kann er nur sterben, nur sterben.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0006.vue?107a1db1